import apiService from "./apiService";
import AppConstants from "../appConstants";

class SigaInstanceService {
    getAllSigaInstance(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_SIGA_INSTANCE, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getSigaInstanceDetails(id, params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_SIGA_INSTANCE}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    registerSigaInstance(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_SIGA_INSTANCE, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deleteSigaInstance(id, params) {
        return new Promise((resolve, reject) => {
            apiService.delete(`${AppConstants.URL_SIGA_INSTANCE}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
}

export default new SigaInstanceService();
